const SERVER_ROUTE = 'https://resume-folio-backend.vercel.app';
const USER_SERVER = 'https://resume-folio-backend.vercel.app/api/users';

// const SERVER_ROUTE = 'http://localhost:5000';
// const USER_SERVER = 'http://localhost:5000/api/users';

export {
    SERVER_ROUTE,
    USER_SERVER
};
